import { PERMISSIONS } from "../../app/utils/Permissions";

const P = PERMISSIONS.EMBARCADORA;

import { Constants } from '../../app/utils/Constants';

export default {
	header: {
		self: {},
		items: [
			{
				title: "Suporte via WhatsApp",
				root: true,
				alignment: "left",
				link: Constants.whatsappLink,
				icon: "fab fa-whatsapp",
			},
		]
	},
	aside: {
		self: {},
		items: [
			{
				title: "Dashboard",
				root: true,
				icon: "fas fa-tachometer-alt",
				page: "embarcador/dashboard",
				permission: P.DASHBOARD_VIEW,
				bullet: "dot"
			},
			{
				title: "Favoritos",
				root: true,
				icon: "fas fa-star",
				bullet: "dot",
				submenu: [
					{
						title: "Transportadoras",
						bullet: "dot",
						page: "embarcador/favorito/transportadoras",
				permission: P.FAVORITO_EMBARCADORA_LIST,
					},
				]
			},
			{
				title: "Torre de Controle",
				root: true,
				icon: "fas fa-broadcast-tower",
				bullet: "dot",
				submenu: [
					{
						title: "Monitoramento",
						bullet: "dot",
						page: "embarcador/torre/monitoramento",
					},
				]
			},
			{
				title: "Painel de Ofertas",
				root: true,
				icon: "fas fa-comments-dollar",
				bullet: "dot",
				submenu: [
					{
						title: "Gestão de Ofertas",
						bullet: "dot",
						page: "embarcador/painel-oferta",
					},
					{
						title: "Viagens",
						bullet: "dot",
						page: "embarcador/painel-oferta/viagens",
					},
					{
						title: "Projeção de Fluxo",
						bullet: "dot",
						page: "embarcador/painel-oferta/projecao",
					},
				]
			},
			// {
			// 	title: "Fretes",
			// 	root: true,
			// 	icon: "fas fa-location-arrow",
			// 	page: "embarcador/frete",
			// 	bullet: "dot"
			// },
			// {
			// 	title: "Classificação",
			// 	root: true,
			// 	icon: "fas fa-file",
			// 	page: "embarcador/classificacao",
			// 	bullet: "dot"
			// },
			{
				title: "Programações",
				root: true,
				icon: "fas fa-calendar",
				bullet: "dot",
				submenu: [
					{
						title: "Gestão Operacional",
						bullet: "dot",
						page: "embarcador/programacao",
				permission: P.PROGRAMACAO_LIST,
					},
					{
						title: "Agendamentos",
						bullet: "dot",
						page: "embarcador/agendamentos",
				permission: P.AGENDAMENTO_LIST
					},
					{
						title: "Planejamento",
						bullet: "dot",
						page: "embarcador/programacao/calendario",
				permission: P.PROGRAMACAO_LIST,
					},
				]
			},
			{
				title: "Parâmetros Operacionais",
				root: true,
				icon: "fas fa-sliders-h",
				bullet: "dot",
				armazem: true,
				submenu: [
					{
						title: "Turno de Operação",
						bullet: "dot",
						page: "embarcador/parametros-operacionais/turnos",
				permission: P.ARMAZEM_TURNO_LIST,
						armazem: true,
					},
					{
						title: "Reservas de Vagas",
						bullet: "dot",
						page: "embarcador/parametros-operacionais/reservas",
				permission: P.ARMAZEM_TURNO_CLIENTE_LIST,
						armazem: true,
					},
					{
						title: "Agendamento",
						bullet: "dot",
						page: "embarcador/parametros-operacionais/agendamento",
				permission: P.ARMAZEM_CONFIGURACAO_AGENDAMENTO_VIEW,
						armazem: true,
					},
					{
						title: "Produtos",
						bullet: "dot",
						page: "embarcador/parametros-operacionais/produtos",
						permission: P.EMPRESA_PRODUTO_LIST,
					},
					{
						title: "Acondicionamento",
						bullet: "dot",
						page: "embarcador/parametros-operacionais/acondicionamento",
						permission: P.PRODUTO_ACONDICIONAMENTO_LIST,
					},
				]
			},
			// {
			// 	title: "Pátio",
			// 	root: true,
			// 	bullet: "dot",
			// 	icon: "fas fa-parking",
			// 	submenu: [
			// 		{
			// 			title: "Dashboard",
			// 			bullet: "dot",
			// 			page: "embarcador/patio/dashboard"
			// 		},
			// 		{
			// 			title: "Serviços",
			// 			bullet: "dot",
			// 			submenu: [
			// 				{
			// 					title: "Limpeza",
			// 					bullet: "dot",
			// 					page: "embarcador/patio/comprar/limpeza"
			// 				},
			// 				{
			// 					title: "Estacionamento",
			// 					bullet: "dot",
			// 					page: "embarcador/patio/comprar/estacionamento"
			// 				},
			// 				{
			// 					title: "Classificação de Produto",
			// 					bullet: "dot",
			// 					page: "embarcador/patio/comprar/classificacao"
			// 				},
			// 			]
			// 		},
			// 		{
			// 			title: "Relatórios",
			// 			bullet: "dot",
			// 			submenu: [
			// 				{
			// 					title: "Cobrança",
			// 					bullet: "dot",
			// 					page: "embarcador/patio/relatorio/relatorio01"
			// 				},
			// 			]
			// 		},
			// 	]
			// },
			{
				title: "Meus Locais",
				root: true,
				icon: "fas fa-industry",
				page: "embarcador/locais",
				permission: P.LOCAL_LIST,
				bullet: "dot",
				armazem: true,
			},
			{
				title: "Relatórios",
				root: true,
				bullet: "dot",
				icon: "fas fa-chart-pie",
				submenu: [
					{
						title: "Transportadoras x Cargas",
						bullet: "dot",
						page: "embarcador/relatorio/relatorio01",
				permission: P.TRANSPORTADOR_LIST
					},
					// {
					// 	title: "Cargas x Região",
					// 	bullet: "dot",
					// 	page: "embarcador/relatorio/relatorio02"
					// },
					// {
					// 	title: "Transportadoras x Produtos",
					// 	bullet: "dot",
					// 	page: "embarcador/relatorio/relatorio03"
					// },
				]
			},
			// {
			// 	title: "FastFrete Log",
			// 	root: true,
			// 	icon: "fas fa-truck",
			// 	page: "embarcador/log",
			// 	bullet: "dot"
			// },
		]
	}
};